export default class Config {
  public static data: any
  public static async loadConfig(url: string = './config.json') {
    let res = await fetch(url)
    let configJson = await res.json()
    Config.data = configJson
  }
}